import React from "react";
import Modal from "../../components/modal";
import Cards from "../../components/cards";
import { mobileView } from "../viewType";
import urlContain from "../../utils/urlContain";

function SingleImageModal({ closeImageSlideShow, imageUrl, modalData }) {
	const close = () => {
		closeImageSlideShow();
	};

	return (
		<Modal>
			<Modal.ModalWrapper>
				<div
					style={{
						backgroundColor: "#FFFFFF",
						width: mobileView ? "98%" : "60%",
						height: "auto",
						padding: mobileView ? "5px" : "12px",
					}}
				>
					<div>
						<Cards.TitleContainer
							style={{ display: "flex", alignItems: "center" }}
						>
							<Cards.TextContainer>
								<Cards.Title>
									{modalData?.["MAKE"]} {modalData?.["MODEL system"]}
								</Cards.Title>
								<Cards.SmallText>Brand: {modalData?.["MAKE"]}</Cards.SmallText>
							</Cards.TextContainer>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Cards.MoreInfoButton
									onClick={close}
									style={{
										marginLeft: "auto",
										marginTop: "6px",
										marginBottom: "6px",
									}}
								>
									CLOSE
									<img src="../../assets/icons/close.svg" alt="close" />
								</Cards.MoreInfoButton>
							</div>
						</Cards.TitleContainer>
					</div>
					<div style={{ width: "100%"}}>
						<img src={urlContain(imageUrl)} alt="" style={{ width: "100%", height: "300px", objectFit: "contain" }} />
					</div>
				</div>
			</Modal.ModalWrapper>
		</Modal>
	);
}

export default SingleImageModal;
